import * as React from "react";
import Iauto1 from "../Images/iauto1.png";

function Hero() {
  return (
    <div>
      <div className="flex gap-5 px-16 py-0 max-md:flex-col max-md:gap-0">
        <div className="flex flex-col w-[54%] max-md:ml-0 max-md:w-full">
          <div className="flex flex-col self-stretch px-5 my-auto text-black max-md:mt-10 max-md:max-w-full">
            <div className="text-5xl font-extrabold leading-[65.1px] max-md:max-w-full">
              Switch to Solar Energy Today
            </div>
            <div className="mt-5 text-lg font-medium leading-9 lowercase whitespace-nowrap text-ellipsis max-md:max-w-full">
              Save money and help the environment
            </div>
            <div className="justify-center self-start py-1.5 pr-10 pl-1.5 mt-6 text-xl font-bold text-white bg-cyan-700 rounded-md shadow-lg max-md:px-5">
              Get A Free Quote
            </div>
          </div>
        </div>
        <div className="flex flex-col ml-5 w-[46%] max-md:ml-0 max-md:w-full">
          <img
            loading="lazy"
            src={Iauto1}
            className="grow w-full aspect-[0.9] max-md:mt-10 max-md:max-w-full"
          />
        </div>
      </div>
    </div>
  );
}

export default Hero;
